"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactContentLoader = _interopRequireDefault(require("react-content-loader"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SideBarLoader = function SideBarLoader(props) {
  return _react["default"].createElement(_reactContentLoader["default"], {
    height: "45",
    backgroundColor: "#212121",
    foregroundColor: "#191919"
  }, _react["default"].createElement("rect", {
    x: "0",
    y: "5",
    rx: "3",
    ry: "3",
    width: "220",
    height: "40"
  }));
};

var _default = SideBarLoader;
exports["default"] = _default;